module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAAAXNSR0IArs4c6QAAAF5JREFUCB1jfCZlzMWABCQlGX4zXmCW3sXwn8EVJs7MyBjExMzI0gATYGBgvKjz5/EGJt0/D48xMDLsBkkwMzI0MjIy/gcruswib3WBSebC////GRG6gKwL7EpqMAEASfoV54WvYCsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Triangle.png
// module id = pBKx
// module chunks = 3